// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/img/successWithdraw.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.successMain {
  background-color: #07405e;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100dvh;
  position: fixed;
}
.successMain .successContainer {
  height: 85%;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100dvh;
  padding: 10px;
}
@media (min-width: 450px) {
  .successMain .successContainer {
    width: 400px;
  }
}
@media only screen and (max-height: 712px) {
  .successMain .successContainer {
    height: 100%;
  }
}
.successMain .successContainer .successImage {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 350px;
  height: 350px;
  background-size: cover;
  margin-top: 10dvh;
  position: relative;
}
.successMain .successContainer .apiMessage {
  color: #FFFFFF;
  font-weight: 900;
  line-height: 110%;
  text-align: center;
  font-family: "Crimson Pro", serif;
  margin-top: 90px;
}
.successMain .successTitle {
  font-family: "Bitter", serif;
  font-family: "Crimson Pro", serif;
  font-size: 30px;
  font-style: normal;
  font-weight: 900;
  line-height: 110%;
  color: #FFFFFF;
  position: absolute;
  width: 100%;
  bottom: -60px;
  text-align: center;
  padding: 0;
}
@media only screen and (min-height: 712px) {
  .successMain .successTitle {
    margin: 30px 0 0 0;
  }
}
.successMain .successMessage {
  color: #699BB6;
  text-align: center;
  font-family: "Bitter", serif;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 110%;
  position: absolute;
  bottom: -170px;
  padding: 0px 20px 0px 20px;
}
.successMain .continueButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 320px;
  background: linear-gradient(to right, #6D4ECB, #FF6B6B);
  font-weight: 400;
  margin-top: 50px;
  padding: 15px;
  border-radius: 10px;
  text-align: center;
  color: #FFFFFF;
  font-family: "Roboto", sans-serif;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  border: 0px solid;
  position: absolute;
  bottom: 30px;
}`, "",{"version":3,"sources":["webpack://./src/modules/withdraw/withdrawSuccess/index.scss","webpack://./src/scss/colors.scss","webpack://./src/scss/fonts.scss"],"names":[],"mappings":"AAIA;EACI,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;AAFJ;AAGI;EAIM,WAAA;EAIA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;AAPV;AALQ;EADJ;IAEQ,YAAA;EAQV;AACF;AANU;EALN;IAMQ,YAAA;EASV;AACF;AAFQ;EACI,yDAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AAIZ;AADQ;EACI,cCpCC;EDqCD,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iCEtCE;EFuCF,gBAAA;AAGZ;AAAI;EACI,4BE5CC;EF6CD,iCE5CM;EF6CN,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cCnDK;EDoDL,kBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EAIA,UAAA;AADR;AAFQ;EAZJ;IAaQ,kBAAA;EAKV;AACF;AAFI;EACI,cC7DS;ED8DT,kBAAA;EACA,4BE/DC;EFgED,iCE5DC;EF6DD,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,0BAAA;AAIR;AAFI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,uDAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cCrFK;EDsFL,iCEjFC;EFkFD,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;AAIR","sourcesContent":["@import '../../../scss/colors.scss';\n@import '../../../scss/fonts.scss';\n\n\n.successMain{\n    background-color: #07405e;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n    height: 100dvh;\n    position: fixed;\n    .successContainer{\n        @media (min-width: 450px) {\n            width: 400px;\n          }\n          height: 85%;\n          @media only screen and (max-height: 712px) {\n            height: 100%;\n          }\n          display: flex;\n          align-items: center;\n          flex-direction: column;\n          width: 100%;\n          height: 100dvh;\n          padding: 10px;\n        .successImage{\n            background-image: url('../../../assets/img/successWithdraw.png');\n            width: 350px;\n            height: 350px;\n            background-size: cover;\n            margin-top: 10dvh;\n            position: relative;\n\n        }\n        .apiMessage{\n            color: $color-White;\n            font-weight: 900;\n            line-height: 110%;\n            text-align: center;\n            font-family: $Crimson-Pro;\n            margin-top: 90px;\n        }\n    }\n    .successTitle{\n        font-family: $Bitter;\n        font-family: $Crimson-Pro;\n        font-size: 30px;\n        font-style: normal;\n        font-weight: 900;\n        line-height: 110%;\n        color: $color-White;\n        position: absolute;\n        width: 100%;\n        bottom: -60px;\n        text-align: center;\n        @media only screen and (min-height: 712px) {\n            margin:30px 0 0 0 ;\n        }\n        padding:0;\n    }\n    .successMessage{\n        color: $color-Secondary;\n        text-align: center;\n        font-family: $Bitter;\n        font-family: $Roboto;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 110%;\n        position: absolute;\n        bottom: -170px;\n        padding:0px 20px 0px 20px;\n    }\n    .continueButton{\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 320px;\n        background: linear-gradient(to right, $color-Gradient-3-1, $color-Gradient-2-2);\n        font-weight: 400;\n        margin-top: 50px;\n        padding: 15px;\n        border-radius: 10px;\n        text-align: center;\n        color: $color-White;\n        font-family: $Roboto;\n        text-align: center;\n        font-size: 16px;\n        font-style: normal;\n        border:0px solid;\n        position: absolute;\n        bottom: 30px;\n    }\n\n    \n}","$color-White:#FFFFFF;\n$color-Secondary:#699BB6;\n\n$color-Gradient-1-2:#002F48;\n$color-Gradient-2-2:#FF6B6B;\n$color-Gradient-3-2:#987EE4;\n$color-Gradient-4-2:#F595DF; \n$color-Gradient-5-2:#FEA5A5;\n\n$color-Gradient-1-1:#216B93;\n$color-Gradient-2-1:#F595DF;\n$color-Gradient-3-1:#6D4ECB;\n$color-Gradient-4-1:#C465AE;\n\n","@import url('https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap');\n$Bitter: 'Bitter', serif;   \n$Crimson-Pro: 'Crimson Pro', serif;\n$Alfa-Slab-One: 'Alfa Slab One', serif;\n$Noto-Serif: 'Noto Serif', serif;\n$Roboto: 'Roboto', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
